import { CacheByArgumentStrings } from '../mem/cache-by-argument-strings';
import logging from '../logging';

const log = logging('html');

const doCSSInjection = (content: string): CSSStyleSheet => {
    const sheet = new CSSStyleSheet();
    sheet.replace(content).catch(log.error);
    document.adoptedStyleSheets.push(sheet);
    return sheet;
}

/**
 * Creates a CSSStyleSheet element with the given content (do not pass a style
 * tag), and injects it into the current document, or retreives the previously
 * injected stylesheet that was created with the same text content. Ideally the
 * injection would be done as early as possible to minimize rendering delays or
 * re-renders.
 */
export const injectCSS = CacheByArgumentStrings.memoize(doCSSInjection);
export default injectCSS;
